/********************************************
* Image lazy-loading
********************************************/

/**
* Background: 		<div class="lazy" data-bg="url(../img/44721746JJ_15_a.jpg)"></div>
* Image: 			<img class="lazy" data-src="../img/44721746JJ_15_a.jpg">
*/
function fnLazyLoad( i, oSection ) {

	var myLazyLoad = new LazyLoad({
	    elements_selector: '.lazy',
	    callback_enter : function( el ) {

	    	$( el ).addClass( 'lazy-loaded' );

	    }
	});

};


// END OF DOCUMENT
